export default {
    user: {
        alert: {
            updated: "Compte mis à jour",
            created: "Compte créé"
        },
        removeAccount: {
            button: "Supprimer le compte",
            confirm: "Etes-vous sûre de vouloir supprimer votre compte ?"
        },
        register: {
            title: "Créer un compte",
            confirmation: {
                title: "Merci pour la création de votre compte",
                body: "Un email vous a été envoyé pour confirmer la création"
            },
            activation: {
                title: "Le compte à bien été activé",
                body: "Vous pouvez désormais vous connecter"
            }
        },
        dataExport: {
            link: "Télécharger les données",
            fileName: "Données utilisateur.json"
        },
        field: {
            email: "Email",
            password: "Mot de passe",
            passwordCheck: "Confirmation du mot de passe",
            newPassword: "Nouveau mot de passe",
            alias: "Pseudonyme",
            maritalStatus: "Situation congugale",
            maritalStatusOptions: {
                singleMale: "Seul",
                singleFemale: "Seule",
                couple: "Couple"
            },
            maleBirthYear: "Année de naissance homme",
            femaleBirthYear: "Année de naissance femme",
            language: "Langue",
            acceptNotifications: "Notifications",
            isAdult: "Je certifie sur l'honneur être majeur selon la loi en vigueur dans mon pays",
            tosAccept: "J'ai lu les conditions générales d'utilisation",
        },
        facebook: {
            loginButton: "Connecter avec Facebook",
            createAccountMessage: "Le compte sera créé avec les informations de Facebook",
            createAccountButton: "Créer le compte",
            editPermissionButton: "Modifier les permission de Facebook"
        },
        auth: {
            login: 'Se connecter',
            error: {
                login: 'Email ou mot de passe incorrect',
                expired: 'La session a expiré'
            }
        }
    },
    question: {
        zeroPool: {
            error: "Vous n'avez plus de question",
            message: "Vous pouvez ajouter des questions à partir de la ",
            previous: "Retour à la question précèdente"
        },
        form: {
            previous: "Précédent",
            validate: "Valider",
            next: "Suivant (Sauter la question)",
            fantasy: "Fantasme",
            action: "Action",
            gauge: "Excitation",
            complement: "Complément",
            errors: {
                answerRequired: "Une réponse doit être sélectionnée",
                noQuestionAvailable: "Pas de question disponible en Français"
            },
            helptexts: {
                complement: "Complément d'information",
                question: "La question",
                answers: "Votre réponse",
                gaugeTitle: "Gauge",
                gauge: "Représente le niveau d'excitation inspiré par la question",
                fantasyTitle: "Bouton Fantasme",
                fantasy: "Le sujet est un fantasme pour vous",
                actionTitle: "Bouton Action",
                action: "La question vous incite à essayer",
            },
            bookmark : "Favori",
        },
        finished: {
            leadMessage: "Félicitation ! Vous avez fini les questions !",
            unansweredMessage: "Néanmoins il vous reste {0} questions sans réponse",
            unansweredLink: "Voir mes questions sans réponse",
            myAnswers: "Voir toutes mes réponses",
            allPacks: "Voir les autres thématiques",
            nextPack: "Thématique suivante",
        },
        skipConfirm: "Êtes-vous sûr de vouloir continuer ?\nVos modifications ne seront pas prises en compte."
    },
    userAnswers: {
        fields: {
            notion: "Notion",
            vision: "Vision",
            theme: "Thème",
            fantasy: "Fantasme",
            action: "Action",
            gauge: "Excitation",
            answerWeight: "Poids",
            gaugeLevel: "Excitation",
            skipped: "Sans réponse",
            bookmark: "Favori"
        },
        stats: {
            filters: "Filtres",
            Q: "Q",
            A: "R",
            empty: "Aucune réponse",
            helptexts: {
                gaugeTitle: "Filtre jauge",
                gauge: "Les curseurs min/max permettent de filtrer la plage de jauge inclusive",
                actionTitle: "Filtre action",
                action: "N'affiche que les réponses pour lesquelles le bouton Action a été sélectionné",
                fantasyTitle: "Filtre fantasme",
                fantasy: "N'affiche que les réponses pour lesquelles le bouton Fantasme a été sélectionné",
                skippedTitle: "Filtre sans réponse",
                skipped: "N'affiche que les questions sans réponses",
                bookmarkTitle: "Filtre Favori",
                bookmark: "N'affiche que les questions sauvegardées en favories"
            }
        },
    },
    contacts: {
        description: "Vos amis sont listés ci-dessous. Vous pouvez voir leurs réponses en cliquant dessus",
        list: {
            add: "Ajouter",
            refresh: "Recharger",
            empty: "Vous n'avez aucun ami. Un ami peut être ajouté à partir de son code. Un code peut être généré à l'aide du bouton Ajouter."
        },
        addModal: {
            title: "Ajouter un ami",
            currentToken: "Code à usage unique valable jusqu'à {0}",
            getToken: "Générer un code",
            contactToken: "Ajouter le code d'un ami",
            submitToken: "Ajouter",
            scanQR: "Scanner le QRCode",
            getQR: "Générer un QRCode",
            currentQR: "QRCode à usage unique valable jusqu'à {0}",
            success: "Ami {0} ajouté",
            emailAddress: "Demande d'ami par email",
            emailAddressPlaceholder: "Email de l'ami",
            emailSubmit: "Envoyer",
            emailSendSuccess: "La demande d'ami a bien été envoyé",
            addTypes: {
                token: "Partager code",
                scan: "Partager QRCode",
                email: "Invitation mail",
            },
            error: {
                token: "Code d'ami invalide"
            }
        },
        addModalQR: {
            back: "Retour",
            error: {
                cameraNotGranted: 'Permission d\'appareil photo non autorisée',
                cameraNotFound: 'Appareil photo non détecté',
                cameraNotSupported: 'Appareil photo non supporté',
                cameraInUse: 'Appareil photo en cours d\'utilisation',
                unknown: 'Erreur de connection à l\'appareil photo '
            }
        },
        addURL: {
            confirmation: "Ajouter l'ami avec le code {0} ?"
        },
        removeModal: {
            title: "Suppression de l'ami",
            message: "Êtes-vous sur de vouloir supprimer cet ami ?"
        },
        show: {
            title: "Réponses de {0}",
            back: "Retour",
            remove: "Supprimer",
        },
        error: {
            selfContact: "L'utilisateur en cours ne peut pas s'ajouter en ami"
        }
    },
    offers: {
        success: "Achat effectué avec succès",
        list: {
            marketplace: "Boutique",
            empty: "Aucun thématique trouvé",
            title: "Offre",
            question: "question(s)",
            description: {
                text1: "Pour information, le nombre de questions proposées peut varier en fonction de vos réponses. Vous disposez aujourd'hui de &hearts;&nbsp;<b>{questionPool}</b> questions, votre progression dans le questionnaire vous permet de répondre prochainement à un minimum de &hearts;&nbsp;<b>{minRemainingQuestions}</b> questions.",
                text2: "Le nombre de questions requis pour finir est donc de <b>&hearts;&nbsp;{missingPool}</b>.",
                text3: "Vous disposez donc de suffisamment de questions pour finir."
            }
        },
        notPurchasable: "Ce pack dépasse le nombre de questions requis.",
    },
    packs: {
        payment: {
            cancelled: "La transaction à été annulée",
            transactionError: "Données de transaction inattendues",
            success: "Paiement accepté"
        },
        list: {
            marketplace: "Boutique",
            empty: "Aucune thématique trouvé",
            play: "Jouer"
        },
        fields: {
            description: "Description"
        }
    },
    index: {
        discover: "Découvrir",
        title: "Nouvelles",
        data: "Accueil"
    },
    about: {
        title: "À propos",
        data: "<p class=\"text-justify\">Bienvenue dans l’univers de <span class=\"font-weight-bold\">DeepLov.</span></p>"
        + "<p class=\"text-justify\">Notre but est simple, faire que votre <span class=\"font-weight-bold\">couple</span> reste à l’écoute de ses <span class=\"font-weight-bold\">envies</span> sexuelles.</p>"
        + "<p class=\"text-justify\">Nous avons pensé, avec justesse nous l’espérons, que la <span class=\"font-weight-bold\">femme</span> détenait de nombreuses clés pour <span class=\"font-weight-bold\">libérer</span> le potentiel sexuel au sein de son couple. C’est pourquoi, l’ensemble des questions s’adressent uniquement à elle.</p>"
        + "<p class=\"text-justify\">Articulé autour de nombreux thèmes de <span class=\"font-weight-bold\">sexualité</span>, des plus admis aux plus confidentiels, DeepLov vous invite à livrer vos propres désirs, attentes et <span class=\"font-weight-bold\">fantasmes</span> sexuels, mais aussi, à confier votre perception sur de nombreux sujets concernant votre <span class=\"font-weight-bold\">partenaire</span> masculin.</p>"
        + "<p class=\"text-justify\">Alors Messieurs, ne soyez pas frustrés, votre femme, amie, compagne, concubine, <span class=\"font-weight-bold\">amoureuse</span>, pourrait bien vous faire des <span class=\"font-weight-bold\">révélations</span>. Soyez heureux que cela se produise. Elle a des envies dont elle n’avait jamais parlé, prenez-le comme une preuve de grande <span class=\"font-weight-bold\">confiance</span>. Restez ouvert. Si vous n’aviez jamais osé lui révéler une de vos envies, alors qu’elle vous en parle positivement, n’hésitez pas à le lui dire.</p>"
        + "<p class=\"text-justify\">DeepLov peut se jouer en couple, mais il est également possible de laisser sa partenaire répondre seule puis de partager et d’échanger ensuite avec elle sur ses réponses.</p>"
        + "<p class=\"text-justify\">Il est temps de jouer maintenant !</p>"
    },
    help: {
        title: "Aide",
        data: "<h4>Principe</h4>"
        + "<p class=\"text-justify\">Des centaines de questions vous sont proposées autour de nombreux thèmes. Toutes les réponses doivent être apportées uniquement par la partenaire feminine sein du couple.</p> <p>Nous vous conseillons de jouer à deux. Néanmoins une variante possible consiste à laisser la femme répondre seule aux questions pour ensuite livrer ses réponses à son partenaire.<p>"
        + "<h4 class=\"mt-4\">Comment répondre</h4>"
        + "<p class=\"text-justify\">À chaque question peut être associé un groupe de réponses, un bouton <span class=\"font-weight-bold\">Action</span>, un bouton <span class=\"font-weight-bold\">Fantasme</span>, une <span class=\"font-weight-bold\">Jauge</span> d'excitation, une <span class=\"font-weight-bold\">Etoile</span> en haut à droite de chaque question.</p>"
        + "<p class=\"text-justify\">Pour la jauge déplacez le curseur à votre convenance. C'est un complèment à votre réponse</p>"
        + "<p class=\"text-justify\">Cliquez sur <span class=\"font-weight-bold\">Action</span> lorsque vous vous sentez prête à passer potentiellement à l’action concernant le sujet de la question. Cela ne revêt pas un caractère d’immédiateté (avis au partenaire).</p>"
        + "<p class=\"text-justify\">Cliquez sur <span class=\"font-weight-bold\">Fantasme</span> lorsque vous estimez qu’il serait possible de jouer avec le sujet de la question lors de vos ébats amoureux. Cela n’implique aucunement le désir de passer à l’acte.</p>"
        + "<p class=\"text-justify\">Utilisez la <span class=\"font-weight-bold\">jauge</span> d’excitation lorsqu’elle se présente pour simplement préciser, de façon plus ludique l’intérêt ou l’excitation que peut représenter le sujet de la question.</p>"
        + "<p class=\"text-justify\">Cliquez sur l'<span class=\"font-weight-bold\">étoile</span> pour marquer une question afin de la retrouver plus tard grace au filtre dans la rubrique Mes réponses.</p>"
        + "<h4 class=\"mt-4\">Mes réponses</h4>"
        + "<p class=\"text-justify\">Jouez avec les filtres et retrouvez toutes vos réponses sous différentes approches.</p>"
    },
    contactForm: {
        subject: "Sujet",
        message: "Message",
        from: "De",
        response: {
            success: "Message envoyé avec succès"
        },
        subjects: {
            accountRemoval: "Suppression du compte",
            functionalQuestion: "Question fonctionnelle",
            technicalFeedback: "Question technique",
            suggestion: "Suggestion",
            other: "Autre"
        },
    },
    passwordRecovery: {
        successSendEmail: "L'email de réinitialisation à bien été envoyé",
        success: "Le mot de passe à bien été reinitialisé",
        title: "Mot de passe oublié ?",
        placeholder: "Votre email enregistré",
        error: {
            wrongEmail: "Email incorrect",
            passwordsNoMatch: "Les mots de passe ne correspondent pas",
            invalidToken: "Le lien de réinitialisation à expiré",
            emailNotExist: "Cette adresse email n'existe pas",
        }
    },
    global: {
        catchPhrase: "Jeu de haute intimité",
        error: {
            submission: "Erreur de validation",
            paypal: "Erreur PayPal"
        },
        loading: "Chargement",
        form: {
            submit: "Valider",
        },
        menu: {
            title: "DeepLOV",
            about: "À propos",
            help: "Aide",
            questions: {
                label: "Questions",
                continue: "Jouer",
                packs: "Thématiques",
                myAnswers: "Mes réponses",
                myAnswersResponsive: "Réponses",
                question: "question(s)"
            },
            marketplace: "Plus de questions",
            marketplaceResponsive: "Plus",
            login: "Connexion",
            logout: "Déconnexion",
            register: "Créer un compte",
            settings: "Réglages",
            contacts: "Amis",
            questionPool: "Nombre de questions disponibles",
            contactForm: "Contactez-nous",
            tos: "CGU & CGV"
        },
        message: {
            giveAway: "20 nouvelles questions sont accessibles !"
        },
        modal: {
            ok: "Valider",
            cancel: "Annuler",
        },
        next: "Page suivante",
        previous: "Page précédente",
        first: "Première page",
        last: "Dernière page",
        back: "Retour"
    },
    transactions: {
        title: "Mes transactions",
        price: "Montant",
        questionNumber: "Nombre de questions",
        createdAt: "Date de création"
    }
}



// WEBPACK FOOTER //
// ./src/translations/fr_FR.js